import { getClients } from '../api'

export const useClientManagement = () => {
    return { fetchClients: getClients }
}
